<script setup lang="ts">
import { ref, inject, Ref } from 'vue';
import Button from 'primevue/button';
import RadioButton from 'primevue/radiobutton';

const dialogRef = inject('dialogRef') as Ref;
const listPassenger = dialogRef?.value?.data?.listPassenger;
const onSelectPassenger = dialogRef?.value?.options?.emits?.onSelectPassenger;
const selectedPassenger = ref(null);
</script>

<template>
  <div class="copy-passenger-modal">
    <div class="flex font-bold text-800 mb-2">
      <div class="w-1"></div>
      <div class="w-4">{{ $t('book_form.last_name') }}</div>
      <div class="w-4">{{ $t('book_form.first_name') }}</div>
      <div class="w-4">{{ $t('book_form.middle_name') }}</div>
    </div>
    <div class="list-passenger">
      <div class="flex" v-for="(passenger, pIndex) in listPassenger" :key="'passenger' + pIndex">
        <div class="w-1 py-3 pl-2 pr-3">
          <RadioButton :id="`radio_input${pIndex}`" v-model="selectedPassenger" name="selectedPassenger" :value="passenger" />
        </div>
        <div class="w-4 property-field">{{ passenger.passenger.lastName }}</div>
        <div class="w-4 property-field">{{ passenger.passenger.firstName }}</div>
        <div class="w-4 property-field">{{ passenger.passenger.middleName }}</div>
      </div>
    </div>
    <div class="line"></div>
    <div class="text-right">
      <Button class="bg-primary white-space-nowrap" :disabled="!selectedPassenger" :label="$t('common.buttons.select')" @click="onSelectPassenger(selectedPassenger)" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.copy-passenger-modal {
  width: 600px;
  .line {
    height: 1px;
    background-color: #ccc;
    margin: 1rem 0;
  }
}
.property-field {
  padding: 0.875rem;
  margin: 0.125rem;
  margin-right: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.list-passenger {
  max-height: 200px;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 0.5rem;
  }
  &::-webkit-scrollbar-thumb {
    background: lightblue;
    border-radius: 10px;
  }
}
</style>
